<template>
  <div id="header">
    <div class="left">
      <div class="menu-icon" @click="showOrHideSideBar"><i class="fa fa-bars"></i><span></span></div>
    </div>
    <div class="center">
      <h1><a href="https://easy.com.ar" target="_blank"><img src="../assets/easylogo.png" id="logoeasy"/></a></h1>
    </div>
    <div class="right">
      <div class="menu-icon" @click="showSearch"><i class="fa fa-search"></i><span></span></div>
    </div>
  </div>
</template>
<script>
/* eslint-disable */
export default {
  name: 'HelloWorld',
  data () {
    return {
      msg: 'Welcome to Your Vue.js App'
    }
  },
  methods: {
    showOrHideSideBar () {
      this.$emit('sideBarStatus')
    },
    showSearch () {
      dataLayer.push({
        'event': 'Interacción', // Acá se deja como evento de interacción
        'category': 'Buscador', // Detallar que se realizó un evento con el buscador
        'action': 'Click', // Se registra la acción como un clic
        'tag': ''
      });
      if (window.screen.width < 1000) {
        document.body.style.overflow = 'hidden'
      }
      this.$parent.viewSearch = true
    }
  }
}
</script>
<style>
  #header{width:100%;height:60px;background-color:#E0172F;position:fixed;top:0;z-index:101}
  .left,.right,.center{display:inline-block;vertical-align:middle}
  .left,.right{width:20%;}
  .left{ text-align:left;}
  .right{ text-align:right;}
  .center{width:46%;text-align:center;}
  h1{margin:0px;margin-top:2px;}
  #logoeasy{height:56px;}
  .menu-icon{color:#fff;font-size:2em;}

  @media only screen and (min-width: 1000px) {
    #header{background-color:transparent;}
    .left{background-color:#E0172F;text-align:center;height:35px;padding-top:5px;width:45px;position:absolute;left:0px;border-bottom-right-radius:5px;}
    .left .menu-icon{font-size:1.500em}
    .right{background-color:#fff;box-shadow:0px 0px 1px black;position:absolute;left:0px;top:45px;width:45px;height:40px;padding-top:5px;text-align:center;border-bottom-right-radius:5px;border-top-right-radius:5px;}
    .right .menu-icon{ font-size:1.500em}
    .right .menu-icon i{ color:#E0172F}
    .center{position:absolute;right:0px;width:60px;margin-right:5px;margin-top:5px;}
    .menu-icon{cursor:pointer;}
  }
</style>



// WEBPACK FOOTER //
// src/components/HeaderComponent.vue